import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Fragment } from 'react';
import { Container } from 'reactstrap';
import FooterSection from '../Components/FooterSection';
import HeaderSection from '../Components/HeaderSection';
import SearchComponent from '../Components/SearchComponent';

const mapStateToProps = store => ({
})

const mapDispatchToProps = dispatch => (
  bindActionCreators({
  }, dispatch)
)

class SearchPage extends Component {
  render() {
    return (
      <Fragment>
        <HeaderSection/>
        <Container className="mt-5 mb-5">
          <SearchComponent/>
        </Container>
        <FooterSection/>
      </Fragment>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchPage);